"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1187],{

/***/ 83679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ PWALayout; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
// EXTERNAL MODULE: ./src/hooks/index.ts + 10 modules
var hooks = __webpack_require__(68062);
// EXTERNAL MODULE: ../../packages/cyberlab-uikit/src/index.ts + 192 modules
var src = __webpack_require__(41418);
;// CONCATENATED MODULE: ./src/configs/seo.ts
/* provided dependency */ var process = __webpack_require__(34406);
var META_TAGS = {
    title: "Link3.to | A Web3 Social Network of Verifiable Identities",
    description: "Link3 is a Web3 native social platform built on CyberConnect protocol.",
    image: process.env.NEXT_PUBLIC_APP_URL + "meta/opengraph.png"
};

// EXTERNAL MODULE: ../../node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(55351);
;// CONCATENATED MODULE: ./src/components/MetaTags/index.tsx



var MetaTags = function(param) {
    var _title = param.title, title = _title === void 0 ? META_TAGS.title : _title, _description = param.description, description = _description === void 0 ? META_TAGS.description : _description, _image = param.image, image = _image === void 0 ? META_TAGS.image : _image, url = param.url, canonical = param.canonical, width = param.width, height = param.height;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(next_seo_module/* NextSeo */.PB, {
        title: title,
        description: description,
        canonical: canonical || url || "https://link3.to",
        openGraph: {
            url: url,
            title: title,
            description: description,
            images: [
                {
                    url: image,
                    alt: "A Web3 Social Network of Verifiable Identities",
                    type: "image/png",
                    width: width || 1280,
                    height: height || 640
                }, 
            ],
            site_name: "Link3.to",
            type: "profile"
        },
        twitter: {
            handle: "@link3to",
            site: "https://link3.to",
            cardType: "summary_large_image"
        }
    });
};
/* harmony default export */ var components_MetaTags = (MetaTags);

;// CONCATENATED MODULE: ./src/components/Layout/PWALayout.tsx





function PWALayout(props) {
    var isIOS = (0,hooks/* useIsIOS */.Vm)();
    var footerHeight = isIOS ? 44 : 0;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kqy, {
        sx: {
            paddingBottom: "".concat(footerHeight, "px")
        },
        className: "pwa-layout",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_MetaTags, (0,_object_spread/* default */.Z)({}, props.metadata)),
            props.children
        ]
    });
};


/***/ }),

/***/ 46517:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ isOrgProfile; },
/* harmony export */   "y": function() { return /* binding */ isPersonalProfile; }
/* harmony export */ });
var isPersonalProfile = function(p) {
    return (p === null || p === void 0 ? void 0 : p.__typename) === "PerProfile";
};
var isOrgProfile = function(p) {
    return (p === null || p === void 0 ? void 0 : p.__typename) === "OrgProfile";
};


/***/ }),

/***/ 2390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _cyberlab_uikit__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41418);

var Wrapper = (0,_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_0__/* .styled */ .zop)(_cyberlab_uikit__WEBPACK_IMPORTED_MODULE_0__/* .Stack */ .Kqy)(function(param) {
    var _theme = param.theme, spacing = _theme.spacing, palette = _theme.palette;
    var ref;
    return {
        padding: spacing(2),
        backgroundColor: (ref = palette.bg) === null || ref === void 0 ? void 0 : ref.paper
    };
});
/* harmony default export */ __webpack_exports__["Z"] = (Wrapper);


/***/ }),

/***/ 7451:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "sc": function() { return /* reexport */ useCouldEditProfile/* useCouldEditProfile */.s; },
  "ad": function() { return /* reexport */ useCreateBlocks; },
  "Io": function() { return /* reexport */ useDeleteBlocks; },
  "UY": function() { return /* reexport */ useEnhancedUpdatePersonal; },
  "WQ": function() { return /* reexport */ useLinkedinStatus; },
  "GP": function() { return /* reexport */ useUpdateBlocks; }
});

// UNUSED EXPORTS: useEnhancedUpdateOrgProfile

// EXTERNAL MODULE: ./src/hooks/profile/useCouldEditProfile.ts
var useCouldEditProfile = __webpack_require__(62570);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(94776);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/utils/index.ts + 2 modules
var utils = __webpack_require__(66535);
// EXTERNAL MODULE: ../../packages/utils/index.ts + 27 modules
var packages_utils = __webpack_require__(26292);
// EXTERNAL MODULE: ../../packages/service/pwa/generated/graphql.ts
var graphql = __webpack_require__(51499);
// EXTERNAL MODULE: ../../packages/cyberlab-uikit/src/index.ts + 192 modules
var src = __webpack_require__(41418);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(94449);
;// CONCATENATED MODULE: ./src/hooks/profile/useEnhancedCreateBlock.ts









var useCreateBlocks = function() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,graphql/* useCreateBlockMutation */.Sx6)(), 2), updater = ref[0], result = ref[1];
    var handleUpdate = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var profileId, input, handle, res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        profileId = param.profileId, input = param.input, handle = param.handle;
                        _ctx.next = 3;
                        return updater({
                            profileId: profileId,
                            input: input
                        }).then(function(data) {
                            if ("data" in data && data.data.createBlock.status === graphql/* CreateBlockResponse_Status.Success */.t$W.Success) {
                                return {
                                    isSuccess: true
                                };
                            }
                            return {
                                isSuccess: false
                            };
                        });
                    case 3:
                        res = _ctx.sent;
                        if (res.isSuccess) {
                            dispatch(graphql/* api.endpoints.getProfile.initiate */.hi0.endpoints.getProfile.initiate((0,packages_utils/* getProfileQueryParams */.Vy)(handle), {
                                forceRefetch: true
                            }));
                            src/* toast.success */.Amu.success("Update Successfully!");
                            (0,utils/* revalidateSSGPage */.eb)(handle);
                        }
                        return _ctx.abrupt("return", res);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        updater
    ]);
    return [
        handleUpdate,
        result
    ];
};

;// CONCATENATED MODULE: ./src/hooks/profile/useEnhancedDeleteBlock.ts









var useDeleteBlocks = function() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,graphql/* useDeleteBlockMutation */.pVH)(), 2), deleteTrigger = ref[0], result = ref[1];
    var handleDelete = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var id, handle, res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        id = param.id, handle = param.handle;
                        _ctx.next = 3;
                        return deleteTrigger({
                            id: id
                        }).then(function(data) {
                            if ("data" in data && data.data.deleteBlock.status === graphql/* DeleteBlockResponse_Status.Success */.gPf.Success) {
                                return {
                                    isSuccess: true
                                };
                            }
                            return {
                                isSuccess: false
                            };
                        });
                    case 3:
                        res = _ctx.sent;
                        if (res.isSuccess) {
                            dispatch(graphql/* api.endpoints.getProfile.initiate */.hi0.endpoints.getProfile.initiate((0,packages_utils/* getProfileQueryParams */.Vy)(handle), {
                                forceRefetch: true
                            }));
                            src/* toast.success */.Amu.success("Delete Successfully!");
                            (0,utils/* revalidateSSGPage */.eb)(handle);
                        }
                        return _ctx.abrupt("return", res);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        deleteTrigger
    ]);
    return [
        handleDelete,
        result
    ];
};

;// CONCATENATED MODULE: ./src/hooks/profile/useEnhancedUpdateBlock.ts









var useUpdateBlocks = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,graphql/* useUpdateBlockMutation */.wBp)(), 2), updater = ref[0], result = ref[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var handleUpdate = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var id, input, handle, res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        id = param.id, input = param.input, handle = param.handle;
                        _ctx.next = 3;
                        return updater({
                            id: id,
                            input: input
                        }).then(function(data) {
                            if ("data" in data && data.data.updateBlock.status === graphql/* UpdateBlockResponse_Status.Success */.QjW.Success) {
                                return {
                                    isSuccess: true
                                };
                            }
                            return {
                                isSuccess: false
                            };
                        });
                    case 3:
                        res = _ctx.sent;
                        if (res.isSuccess) {
                            dispatch(graphql/* api.endpoints.getProfile.initiate */.hi0.endpoints.getProfile.initiate((0,packages_utils/* getProfileQueryParams */.Vy)(handle), {
                                forceRefetch: true
                            }));
                            src/* toast.success */.Amu.success("Update Successfully!");
                            (0,utils/* revalidateSSGPage */.eb)(handle);
                        }
                        return _ctx.abrupt("return", res);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        updater
    ]);
    return [
        handleUpdate,
        result
    ];
};

// EXTERNAL MODULE: ./src/hooks/profile/useEnhancedUpdateOrgProfile.tsx
var useEnhancedUpdateOrgProfile = __webpack_require__(99165);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ./src/services/pinFileToIpfs.ts
var pinFileToIpfs = __webpack_require__(34945);
;// CONCATENATED MODULE: ./src/hooks/profile/useEnhancedUpdatePersonal.tsx













var _obj;
var errorMsg = (_obj = {}, (0,_define_property/* default */.Z)(_obj, graphql/* Upload_Status.NotLogin */.U70.NotLogin, "Please login frist"), (0,_define_property/* default */.Z)(_obj, graphql/* Upload_Status.PermissionDenied */.U70.PermissionDenied, "You do not have access to create or update an event. Please contact your admin."), (0,_define_property/* default */.Z)(_obj, graphql/* Upload_Status.SizeExceeded */.U70.SizeExceeded, "Failed to upload image. The maximum size for uploaded images is 1MB."), (0,_define_property/* default */.Z)(_obj, graphql/* Upload_Status.TypeUnsupported */.U70.TypeUnsupported, "Only JPG, PNG, and WEBP file types are supported."), _obj);
var useEnhancedUpdatePersonal = function() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,graphql/* useUpdatePersonalMutation */.rjM)(), 2), updater = ref[0], result = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,graphql/* useUploadProfileBackgroundMutation */.hN9)(), 1), uploadBackground = ref1[0];
    var handleUpdate = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var id, input, handle, profilePicture, backgroundPicture, userUploadAvatarRes, finalAvatar, bgPictureRes, newBackground, res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        id = param.id, input = param.input, handle = param.handle;
                        profilePicture = input.profilePicture, backgroundPicture = input.backgroundPicture;
                        ;
                        if (!(0,packages_utils/* IsBlob */.Ik)(profilePicture === null || profilePicture === void 0 ? void 0 : profilePicture.picture)) {
                            _ctx.next = 10;
                            break;
                        }
                        _ctx.next = 6;
                        return (0,pinFileToIpfs/* pinFileToIPFS */.M)(profilePicture === null || profilePicture === void 0 ? void 0 : profilePicture.picture);
                    case 6:
                        userUploadAvatarRes = _ctx.sent;
                        if (userUploadAvatarRes === null || userUploadAvatarRes === void 0 ? void 0 : userUploadAvatarRes.ipfshash) {
                            _ctx.next = 10;
                            break;
                        }
                        src/* toast.error */.Amu.error("Upload avatar failed, please retry.");
                        return _ctx.abrupt("return", {
                            isSuccess: false
                        });
                    case 10:
                        finalAvatar = (0,packages_utils/* fixNFTIPFSURL */.Ff)((userUploadAvatarRes === null || userUploadAvatarRes === void 0 ? void 0 : userUploadAvatarRes.ipfshash) || (profilePicture === null || profilePicture === void 0 ? void 0 : profilePicture.picture));
                        ;
                        if (!(0,packages_utils/* IsBlob */.Ik)(backgroundPicture === null || backgroundPicture === void 0 ? void 0 : backgroundPicture.picture)) {
                            _ctx.next = 19;
                            break;
                        }
                        _ctx.next = 15;
                        return uploadBackground({
                            file: backgroundPicture === null || backgroundPicture === void 0 ? void 0 : backgroundPicture.picture,
                            profileId: id
                        }).then(function(data) {
                            if ("data" in data) {
                                return {
                                    isSuccess: data.data.uploadProfileImage.status === graphql/* Upload_Status.Success */.U70.Success,
                                    url: data.data.uploadProfileImage.url,
                                    status: data.data.uploadProfileImage.status
                                };
                            }
                            return {
                                isSuccess: false,
                                url: ""
                            };
                        });
                    case 15:
                        bgPictureRes = _ctx.sent;
                        if (bgPictureRes === null || bgPictureRes === void 0 ? void 0 : bgPictureRes.isSuccess) {
                            _ctx.next = 19;
                            break;
                        }
                        src/* toast.error */.Amu.error(bgPictureRes.status ? errorMsg[bgPictureRes.status] : "Upload background picture failed, please retry.");
                        return _ctx.abrupt("return", {
                            isSuccess: false
                        });
                    case 19:
                        newBackground = (bgPictureRes === null || bgPictureRes === void 0 ? void 0 : bgPictureRes.url) || (backgroundPicture === null || backgroundPicture === void 0 ? void 0 : backgroundPicture.picture) || "";
                        _ctx.next = 22;
                        return updater({
                            id: id,
                            input: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, input), {
                                profilePicture: {
                                    type: graphql/* PersonalPicture_Type.General */.peR.General,
                                    picture: finalAvatar
                                },
                                backgroundPicture: {
                                    type: graphql/* PersonalPicture_Type.General */.peR.General,
                                    picture: newBackground
                                }
                            })
                        }).then(function(data) {
                            if ("data" in data && data.data.updatePersonal.status === graphql/* UpdateProfileResponse_Status.Success */.kH7.Success) {
                                return {
                                    isSuccess: true
                                };
                            }
                            return {
                                isSuccess: false
                            };
                        });
                    case 22:
                        res = _ctx.sent;
                        if (res.isSuccess) {
                            dispatch(graphql/* api.endpoints.getProfile.initiate */.hi0.endpoints.getProfile.initiate((0,packages_utils/* getProfileQueryParams */.Vy)(handle), {
                                forceRefetch: true
                            }));
                            dispatch(graphql/* api.endpoints.EasAttestation.initiate */.hi0.endpoints.EasAttestation.initiate((0,packages_utils/* getProfileQueryParams */.Vy)(id), {
                                forceRefetch: true
                            }));
                            dispatch(graphql/* api.endpoints.getProfileIdentities.initiate */.hi0.endpoints.getProfileIdentities.initiate((0,packages_utils/* getProfileQueryParams */.Vy)(id), {
                                forceRefetch: true
                            }));
                            dispatch(graphql/* api.endpoints.me.initiate */.hi0.endpoints.me.initiate(undefined, {
                                forceRefetch: true
                            }));
                            src/* toast.success */.Amu.success("Update Successfully!");
                            (0,utils/* revalidateSSGPage */.eb)(handle);
                        }
                        return _ctx.abrupt("return", res);
                    case 25:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        updater
    ]);
    return [
        handleUpdate,
        result
    ];
};

;// CONCATENATED MODULE: ./src/hooks/profile/useLinkedinStatus.ts

function useLinkedinStatus() {
    var ref, ref1, ref2;
    var data = (0,graphql/* useMeQuery */.UEB)(undefined).data;
    var meData = data === null || data === void 0 ? void 0 : (ref = data.me) === null || ref === void 0 ? void 0 : ref.data;
    var needRefresh = meData === null || meData === void 0 ? void 0 : (ref1 = meData.privateInfo) === null || ref1 === void 0 ? void 0 : ref1.linkedinInfo.needRefresh;
    var isLinked = !!(meData === null || meData === void 0 ? void 0 : (ref2 = meData.privateInfo) === null || ref2 === void 0 ? void 0 : ref2.linkedinId);
    return {
        needRefresh: needRefresh,
        isLinked: isLinked
    };
}

;// CONCATENATED MODULE: ./src/hooks/profile/index.ts









/***/ }),

/***/ 62570:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ useCouldEditProfile; }
/* harmony export */ });
/* harmony import */ var _component_Profile_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46517);
/* harmony import */ var _views_Profile_ProfileConfig_context__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6990);
/* harmony import */ var _cyber_co_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26292);
/* harmony import */ var _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51499);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2784);
/* harmony import */ var _useAuth__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63895);







var COULD_EDIT_PROFILE_ROLE = [
    _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_2__/* .Role.Editor */ .uUj.Editor,
    _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_2__/* .Role.Admin */ .uUj.Admin,
    _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_2__/* .Role.Owner */ .uUj.Owner
];
var useCouldEditProfile = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var handleFromQuery = router.query.handle;
    var ref = (0,_cyber_co_utils__WEBPACK_IMPORTED_MODULE_1__/* .getProfileQueryParams */ .Vy)(handleFromQuery), handle = ref.handle, id = ref.id;
    var isPreview = (0,_views_Profile_ProfileConfig_context__WEBPACK_IMPORTED_MODULE_0__/* .useProfileConfig */ .f)().isPreview;
    var isLoggedIn = (0,_useAuth__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)().isLoggedIn;
    var ref1 = (0,_cyber_service_pwa__WEBPACK_IMPORTED_MODULE_2__/* .useIsAdminQuery */ .hxN)({
        handle: handle,
        id: id
    }, {
        skip: !handle && !id || !isLoggedIn
    }), data = ref1.data, isLoading = ref1.isLoading;
    var profileData = data === null || data === void 0 ? void 0 : data.profile.data;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(undefined), couldEdit = ref2[0], setCouldEdit = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (!isLoggedIn && typeof handle !== "undefined") {
            setCouldEdit(false);
        } else {
            if ((0,_component_Profile_types__WEBPACK_IMPORTED_MODULE_6__/* .isPersonalProfile */ .y)(profileData)) {
                setCouldEdit(!!profileData.isAdmin);
            } else if ((0,_component_Profile_types__WEBPACK_IMPORTED_MODULE_6__/* .isOrgProfile */ .$)(profileData)) {
                // setCouldEdit(COULD_EDIT_PROFILE_ROLE.includes(profileData?.organization.currentAccess));
                setCouldEdit(false);
            }
        }
    }, [
        handle,
        isLoggedIn,
        isLoading,
        data,
        profileData
    ]);
    return {
        isLoading: isLoading,
        couldEdit: couldEdit && !isPreview,
        isPreview: isPreview
    };
};


/***/ }),

/***/ 99165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ useEnhancedUpdateOrgProfile; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47842);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(66383);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94776);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _services_pinFileToIpfs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34945);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66535);
/* harmony import */ var _cyber_co_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26292);
/* harmony import */ var _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51499);
/* harmony import */ var _cyberlab_uikit__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41418);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2784);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(94449);













var _obj;
var errorMsg = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_4__/* .Upload_Status.NotLogin */ .U70.NotLogin, "Please login frist"), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_4__/* .Upload_Status.PermissionDenied */ .U70.PermissionDenied, "You do not have access to create or update an event. Please contact your admin."), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_4__/* .Upload_Status.SizeExceeded */ .U70.SizeExceeded, "Failed to upload image. The maximum size for uploaded images is 1MB."), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_4__/* .Upload_Status.TypeUnsupported */ .U70.TypeUnsupported, "Only JPG, PNG, and WEBP file types are supported."), _obj);
var useEnhancedUpdateOrgProfile = function() {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_7__/* .useDispatch */ .I0)();
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_cyber_service_pwa__WEBPACK_IMPORTED_MODULE_4__/* .useUpdateProfileMutation */ .TGI)(), 2), updater = ref[0], result = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_cyber_service_pwa__WEBPACK_IMPORTED_MODULE_4__/* .useUploadProfileBackgroundMutation */ .hN9)(), 1), uploadBackground = ref1[0];
    var handleUpdate = (0,react__WEBPACK_IMPORTED_MODULE_6__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var id, input, handle, profilePicture, backgroundPicture, userUploadAvatarRes, finalAvatar, bgPictureRes, newBackground, res;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        id = param.id, input = param.input, handle = param.handle;
                        profilePicture = input.profilePicture, backgroundPicture = input.backgroundPicture;
                        ;
                        if (!(0,_cyber_co_utils__WEBPACK_IMPORTED_MODULE_3__/* .IsBlob */ .Ik)(profilePicture)) {
                            _ctx.next = 10;
                            break;
                        }
                        _ctx.next = 6;
                        return (0,_services_pinFileToIpfs__WEBPACK_IMPORTED_MODULE_1__/* .pinFileToIPFS */ .M)(profilePicture);
                    case 6:
                        userUploadAvatarRes = _ctx.sent;
                        if (userUploadAvatarRes === null || userUploadAvatarRes === void 0 ? void 0 : userUploadAvatarRes.ipfshash) {
                            _ctx.next = 10;
                            break;
                        }
                        _cyberlab_uikit__WEBPACK_IMPORTED_MODULE_5__/* .toast.error */ .Amu.error("Upload avatar failed, please retry.");
                        return _ctx.abrupt("return", {
                            isSuccess: false
                        });
                    case 10:
                        finalAvatar = (0,_cyber_co_utils__WEBPACK_IMPORTED_MODULE_3__/* .fixNFTIPFSURL */ .Ff)((userUploadAvatarRes === null || userUploadAvatarRes === void 0 ? void 0 : userUploadAvatarRes.ipfshash) || profilePicture);
                        ;
                        if (!(0,_cyber_co_utils__WEBPACK_IMPORTED_MODULE_3__/* .IsBlob */ .Ik)(backgroundPicture)) {
                            _ctx.next = 19;
                            break;
                        }
                        _ctx.next = 15;
                        return uploadBackground({
                            file: backgroundPicture,
                            profileId: id
                        }).then(function(data) {
                            if ("data" in data) {
                                return {
                                    isSuccess: data.data.uploadProfileImage.status === _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_4__/* .Upload_Status.Success */ .U70.Success,
                                    status: data.data.uploadProfileImage.status,
                                    url: data.data.uploadProfileImage.url
                                };
                            }
                            return {
                                isSuccess: false,
                                url: ""
                            };
                        });
                    case 15:
                        bgPictureRes = _ctx.sent;
                        if (bgPictureRes === null || bgPictureRes === void 0 ? void 0 : bgPictureRes.isSuccess) {
                            _ctx.next = 19;
                            break;
                        }
                        _cyberlab_uikit__WEBPACK_IMPORTED_MODULE_5__/* .toast.error */ .Amu.error(bgPictureRes.status ? errorMsg[bgPictureRes.status] : "Upload background picture failed, please retry.");
                        return _ctx.abrupt("return", {
                            isSuccess: false
                        });
                    case 19:
                        newBackground = (bgPictureRes === null || bgPictureRes === void 0 ? void 0 : bgPictureRes.url) || backgroundPicture || "";
                        _ctx.next = 22;
                        return updater({
                            id: id,
                            input: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, input), {
                                profilePicture: finalAvatar,
                                backgroundPicture: newBackground
                            })
                        }).then(function(data) {
                            if ("data" in data && data.data.updateOrgProfile.status === _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_4__/* .UpdateProfileResponse_Status.Success */ .kH7.Success) {
                                return {
                                    isSuccess: true
                                };
                            }
                            return {
                                isSuccess: false
                            };
                        });
                    case 22:
                        res = _ctx.sent;
                        if (res.isSuccess) {
                            dispatch(_cyber_service_pwa__WEBPACK_IMPORTED_MODULE_4__/* .api.endpoints.getProfile.initiate */ .hi0.endpoints.getProfile.initiate((0,_cyber_co_utils__WEBPACK_IMPORTED_MODULE_3__/* .getProfileQueryParams */ .Vy)(handle), {
                                forceRefetch: true
                            }));
                            _cyberlab_uikit__WEBPACK_IMPORTED_MODULE_5__/* .toast.success */ .Amu.success("Update Successfully!");
                            (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .revalidateSSGPage */ .eb)(handle);
                        }
                        return _ctx.abrupt("return", res);
                    case 25:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        updater
    ]);
    return [
        handleUpdate,
        result
    ];
};


/***/ }),

/***/ 34945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ pinFileToIPFS; }
/* harmony export */ });
/* unused harmony export pinJSONToIPFS */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98788);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94776);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _cyber_service_pwa__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51499);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7229);
//imports needed for this function
// import fs from 'fs';




var pinFileToIPFS = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(file) {
        var res;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return _store__WEBPACK_IMPORTED_MODULE_2__/* .store.dispatch */ .h.dispatch(_cyber_service_pwa__WEBPACK_IMPORTED_MODULE_1__/* .api.endpoints.pinFile.initiate */ .hi0.endpoints.pinFile.initiate({
                        file: file
                    }, undefined));
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", {
                        ipfshash: res.data.pinFileToIPFS.cid
                    });
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        ipfshash: ""
                    });
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function pinFileToIPFS(file) {
        return _ref.apply(this, arguments);
    };
}();
var pinJSONToIPFS = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(json) {
        var res;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return _store__WEBPACK_IMPORTED_MODULE_2__/* .store.dispatch */ .h.dispatch(_cyber_service_pwa__WEBPACK_IMPORTED_MODULE_1__/* .api.endpoints.pinJson.initiate */ .hi0.endpoints.pinJson.initiate({
                        json: JSON.stringify(json)
                    }, undefined));
                case 3:
                    res = _ctx.sent;
                    return _ctx.abrupt("return", res.data.pinJsonToIPFS.cid);
                case 7:
                    _ctx.prev = 7;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", "");
                case 10:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                7
            ]
        ]);
    }));
    return function pinJSONToIPFS(json) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 6990:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ useProfileConfig; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52903);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


var context = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    isPreview: false
});
var ProfileContextProvider = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(context.Provider, {
        value: {
            isPreview: props.isPreview
        },
        children: props.children
    });
};
var useProfileConfig = function() {
    var isPreview = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(context).isPreview;
    return {
        isPreview: isPreview
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (ProfileContextProvider);


/***/ })

}]);